module.exports = __webpack_public_path__ + "static/media/jilongshanadj.4760bfc1.webp";